module.exports = __webpack_public_path__ + "static/media/house.955929ab.svg";